(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Sticky / overlay header */
  const header = $('.header-wrap');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Drawers (menu / cart) */
  $$('[data-open]').forEach(btn => btn.addEventListener('click', e => {
    const d = document.getElementById(btn.dataset.open);
    if (!d) return;
    e.preventDefault();
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }));
  $$('[data-close]').forEach(btn => btn.addEventListener('click', () => {
    btn.closest('.drawer').classList.remove('is-open');
    document.body.style.overflow = '';
  }));
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    document.body.style.overflow = '';
  });

  /* Search toggle */
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    const bar = $('.search-bar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) $('input', bar).focus();
  }));

  /* Copy discount code */
  $$('[data-copy]').forEach(b => b.addEventListener('click', () => {
    navigator.clipboard && navigator.clipboard.writeText(b.dataset.copy);
    b.setAttribute('data-copied', '');
    setTimeout(() => b.removeAttribute('data-copied'), 2000);
  }));

  /* Hero slideshow */
  $$('[data-slideshow]').forEach(root => {
    const slides = $$('.hero__slide', root);
    const dots = $$('.hero__dots button', root);
    const counter = $('[data-counter]', root);
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = n => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
      if (counter) counter.textContent = String(i + 1).padStart(2, '0');
    };
    const play = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), (+root.dataset.speed || 6) * 1000); };
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));
    play();
  });

  /* Tabs */
  $$('[data-tabs]').forEach(root => {
    const btns = $$('[role=tab]', root);
    btns.forEach(btn => btn.addEventListener('click', () => {
      btns.forEach(b => { b.setAttribute('aria-selected', 'false'); $('#' + b.getAttribute('aria-controls')).hidden = true; });
      btn.setAttribute('aria-selected', 'true');
      $('#' + btn.getAttribute('aria-controls')).hidden = false;
    }));
  });

  /* Testimonials */
  $$('[data-quotes]').forEach(root => {
    const q = $$('.quote', root);
    if (q.length < 2) return;
    let i = 0;
    const go = n => { q[i].classList.remove('is-active'); i = (n + q.length) % q.length; q[i].classList.add('is-active'); };
    $('[data-prev]', root).addEventListener('click', () => go(i - 1));
    $('[data-next]', root).addEventListener('click', () => go(i + 1));
    setInterval(() => go(i + 1), 9000);
  });

  /* Before / after */
  $$('.ba input').forEach(r => {
    const set = () => r.closest('.ba').style.setProperty('--pos', r.value + '%');
    r.addEventListener('input', set); set();
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(el => io.observe(el));
  } else {
    $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
  }

  /* Product form: variant selection + qty */
  $$('[data-product-form]').forEach(form => {
    const dataEl = $('[data-variants]', form);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('input[name=id]', form);
    const priceEl = $('[data-price]', form.closest('.pdp') || document);
    const btn = $('[data-add]', form);
    const money = cents => (form.dataset.currency || '₹') + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
    const update = () => {
      const chosen = $$('fieldset.opt', form).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      const v = variants.find(v => v.options.every((o, n) => o === chosen[n]));
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.label : btn.dataset.soldout;
      if (priceEl) priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('fieldset.opt input', form).forEach(i => i.addEventListener('change', update));
  });
  $$('.qty').forEach(q => {
    const input = $('input', q);
    $$('button', q).forEach(b => b.addEventListener('click', () => {
      const v = Math.max(+input.min || 0, (+input.value || 0) + (+b.dataset.step));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
})();
